import axios, {AxiosResponse} from 'axios';
import {
    HomeCaseReportingDeadlineIsApproachingRetrieveResponse,
    HomeEdcSyncStatusRetrieveResponse,
    HomeNoticeDetailRetrieveResponse,
    HomeNoticeRetrieveResponse,
    HomeNoticeAuditTrailsResponse,
    HomeWorkflowRetrieveResponse,
    PopupNoticesResponse,
} from '@/model/CommonModel';
import ApiUtils from '@/utils/ApiUtils';

export default class HomeApi {
    public static retrieveNoticeSummaries(sponsorKey: number): Promise<HomeNoticeRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/home-notices`, {params: {rowCount: 10}})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveCaseReportingDeadlineIsApproachingSummaries(sponsorKey: number):
        Promise<HomeCaseReportingDeadlineIsApproachingRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/home-reports`, {params: {rowCount: 10}})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveEdcSyncStatusSummaries(sponsorKey: number): Promise<HomeEdcSyncStatusRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/home-edcsync`, {params: {rowCount: 10}})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveNotices(sponsorKey: number, params: any = {}): Promise<HomeNoticeRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/notices`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveNoticeDetail(sponsorKey: string | number, noticeKey: string | number): Promise<HomeNoticeDetailRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/notices/${noticeKey}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getNoticeAuditTrails(sponsorKey: number, noticeKey: number, params: any = {}): Promise<HomeNoticeAuditTrailsResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/notices/${noticeKey}/audittrails`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static downloadFileOnNoticeDetailDialog(sponsorKey: number, fileKey: number): Promise<any> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/files/${fileKey}`, {responseType: 'blob'})
            .then((res: any) => ApiUtils.isFailToFileDownloadResponse(res)
                ? ApiUtils.handleFileDownloadFailResponse(res)
                : ApiUtils.handleFileDownloadSuccessResponse(res));
    }

    public static saveNotice(sponsorKey: number | string, noticeKey: number | string, formData: FormData) {
        return axios
            .post(`/1.0/sponsors/${sponsorKey}/notices/${noticeKey}`,
                formData, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'multipart/form-data'
                    }
                })
            .then((res: AxiosResponse) => res.data);
    }

    public static deleteFile(sponsorKey: number | string, fileKey: number, reason: string) {
        return axios
            .delete(`/1.0/sponsors/${sponsorKey}/files/${fileKey}?reason=${reason}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveCaseReportingDeadlineIsApproachings(sponsorKey: number | string, params: any = {}):
        Promise<HomeCaseReportingDeadlineIsApproachingRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/home-report-list`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveEdcSyncStatuses(sponsorKey: number | string, params: any = {}):
        Promise<HomeEdcSyncStatusRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/home-edcsync-list`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveHomeWorkflow(sponsorKey: number | string, params: any = {}):
        Promise<HomeWorkflowRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/home-workflow`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrievePopupNoticeDetail(sponsorKey: number | string): Promise<PopupNoticesResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/popup-notice`)
            .then((res: AxiosResponse) => res.data);
    }
}
